import { render, staticRenderFns } from "./beginRegister.vue?vue&type=template&id=6b25f586&"
import script from "./beginRegister.vue?vue&type=script&lang=js&"
export * from "./beginRegister.vue?vue&type=script&lang=js&"
import style0 from "./beginRegister.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports